exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colorPreview__color___3KZrg {\n  width: 22px;\n  height: 22px;\n  border-radius: 5px;\n  border: solid 1px #c6c6c6;\n  margin-right: 10px;\n  display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"color": "colorPreview__color___3KZrg"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/ReversedRadio/ColorPreview/colorPreview.scss
// module id = 2154
// module chunks = 6